import React from 'react';
import { Pie, Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler
} from 'chart.js';

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler
);


const ApplicationsTab = ({ filters }) => {
  const tableData = [
    { district: 'Деснянський', age1_2: 410, age2_3: 340, age3_4: 160, age4_5: 165, age5_6: 92, age6_7: 175, age7_8: 220, total: 2400, total3_6: 1650 },
    { district: 'Голосіївський', age1_2: 390, age2_3: 315, age3_4: 145, age4_5: 150, age5_6: 85, age6_7: 165, age7_8: 205, total: 2300, total3_6: 1580 },
    { district: 'Солом\'янський', age1_2: 400, age2_3: 330, age3_4: 155, age4_5: 155, age5_6: 90, age6_7: 170, age7_8: 215, total: 2250, total3_6: 1600 },
    { district: 'Оболонський', age1_2: 380, age2_3: 290, age3_4: 125, age4_5: 135, age5_6: 82, age6_7: 162, age7_8: 200, total: 2150, total3_6: 1550 },
    { district: 'Печерський', age1_2: 400, age2_3: 320, age3_4: 150, age4_5: 130, age5_6: 80, age6_7: 160, age7_8: 210, total: 2200, total3_6: 1500 },
    { district: 'Шевченківський', age1_2: 360, age2_3: 300, age3_4: 140, age4_5: 120, age5_6: 75, age6_7: 150, age7_8: 190, total: 2000, total3_6: 1400 },
    { district: 'Святошинський', age1_2: 350, age2_3: 310, age3_4: 135, age4_5: 125, age5_6: 78, age6_7: 155, age7_8: 195, total: 2100, total3_6: 1350 },
    { district: 'Дарницький', age1_2: 370, age2_3: 280, age3_4: 130, age4_5: 140, age5_6: 70, age6_7: 140, age7_8: 185, total: 2050, total3_6: 1300 },
    { district: 'Дніпровський', age1_2: 430, age2_3: 360, age3_4: 175, age4_5: 175, age5_6: 98, age6_7: 185, age7_8: 230, total: 2600, total3_6: 1750 },
    { district: 'Подільський', age1_2: 420, age2_3: 350, age3_4: 170, age4_5: 170, age5_6: 95, age6_7: 180, age7_8: 225, total: 2500, total3_6: 1700 }
  ];

  const totalRow = {
    district: 'По Києву',
    age1_2: 3244,
    age2_3: 3451,
    age3_4: 2898,
    age4_5: 2456,
    age5_6: 3102,
    age6_7: 3210,
    age7_8: 2654,
    total: 22878,
    total3_6: 12399
  };

  const pieData = {
    labels: ['1-2 роки', '2-3 роки', '3-4 роки', '4-5 років', '5-6 років', '6-7 років', '7-8 років'],
    datasets: [
      {
        data: [3244, 3451, 2898, 2456, 3102, 3210, 2654],
        backgroundColor: [
          '#e8a898',
          '#f4d03f',
          '#e74c3c',
          '#58d68d',
          '#a9dfbf',
          '#f7dc6f',
          '#3498db'
        ],
        borderWidth: 0,
      },
    ],
  };

  const lineData = {
    labels: ['1-2', '2-3', '3-4', '4-5', '5-6', '6-7', '7-8'],
    datasets: [
      {
        label: 'Заявки',
        data: [1800, 1600, 1400, 1200, 1000, 800, 600],
        borderColor: '#22C55E',
        backgroundColor: 'rgba(34, 197, 94, 0.1)',
        fill: true,
        tension: 0.4,
        pointRadius: 4,
        pointBackgroundColor: '#22C55E',
      },
    ],
  };

  const lineOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: '#E5E7EB',
        },
        ticks: {
          stepSize: 400,
        },
      },
      x: {
        grid: {
          color: '#E5E7EB',
        },
      },
    },
  };

  const pieOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    cutout: '60%',
  };

  return (
    <>
      <div className="publicstatistic-statistics-table-section">
        <h3 className="publicstatistic-section-title">
          Заявки на {filters.year} навчальний рік
        </h3>

        <div className="publicstatistic-table-responsive">
          <table className="table publicstatistic-statistics-table">
            <thead>
              <tr>
                <th>Район</th>
                <th>1-2 роки</th>
                <th>2-3 роки</th>
                <th>3-4 роки</th>
                <th>4-5 років</th>
                <th>5-6 років</th>
                <th>6-7 років</th>
                <th>7-8 років</th>
                <th>Разом</th>
                <th>Разом 3-6</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  <td className="publicstatistic-district-name">{row.district}</td>
                  <td>{row.age1_2}</td>
                  <td>{row.age2_3}</td>
                  <td>{row.age3_4}</td>
                  <td>{row.age4_5}</td>
                  <td>{row.age5_6}</td>
                  <td>{row.age6_7}</td>
                  <td>{row.age7_8}</td>
                  <td>{row.total}</td>
                  <td>{row.total3_6}</td>
                </tr>
              ))}
              <tr className="publicstatistic-total-row">
                <td className="publicstatistic-district-name"><strong>{totalRow.district}</strong></td>
                <td><strong>{totalRow.age1_2}</strong></td>
                <td><strong>{totalRow.age2_3}</strong></td>
                <td><strong>{totalRow.age3_4}</strong></td>
                <td><strong>{totalRow.age4_5}</strong></td>
                <td><strong>{totalRow.age5_6}</strong></td>
                <td><strong>{totalRow.age6_7}</strong></td>
                <td><strong>{totalRow.age7_8}</strong></td>
                <td><strong>{totalRow.total}</strong></td>
                <td><strong>{totalRow.total3_6}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="publicstatistic-charts-section">
        <div className="row">
          <div className="col-lg-6">
            <div>
              <h4 className="publicstatistic-chart-title">Розподіл заявок за віком</h4>
              <div className="publicstatistic-chart-wrapper">
                <div className="publicstatistic-chart-legend-top">
                  {pieData.labels.map((label, index) => (
                    <div key={index} className="publicstatistic-legend-item">
                      <span
                        className="publicstatistic-legend-color"
                        style={{ backgroundColor: pieData.datasets[0].backgroundColor[index] }}
                      ></span>
                      <span>{label.split(' ')[0]}</span>
                    </div>
                  ))}
                </div>
                <div className="publicstatistic-custom-pie-chart">
                  <div className="publicstatistic-pie-chart-center">
                    <span className="publicstatistic-chart-total">5756</span>
                  </div>
                  <Pie data={pieData} options={pieOptions} />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div>
              <h4 className="publicstatistic-chart-title">Динаміка заявок</h4>
              <div className="publicstatistic-chart-wrapper">
                <div className="publicstatistic-custom-area-chart">
                  <div className="publicstatistic-chart-total-center">
                    <span className="publicstatistic-chart-total">5756</span>
                  </div>
                  <Line data={lineData} options={lineOptions} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApplicationsTab;